export default "__VITE_ASSET__B2bme8ce__"